import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
  withStyles,
} from "@material-ui/core";

// Escotilha de JSON: mostra o layout cru e deixa colar/ajustar direto.
//
// O builder cobre o que a paleta conhece; isso aqui é a saída para o que ela
// não cobre — colar um layout de outro formulário, mexer num tipo legado
// (`table-info`) ou corrigir uma chave na mão. É só para a equipe interna, e
// nada é aplicado sem passar por um `JSON.parse` que exige um array.
class JsonDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      text: JSON.stringify(props.fields || [], null, 2),
      error: "",
    };
  }

  handleApply = () => {
    let parsed;
    try {
      parsed = JSON.parse(this.state.text);
    } catch (e) {
      this.setState({ error: `JSON inválido: ${e.message}` });
      return;
    }

    if (!Array.isArray(parsed)) {
      this.setState({ error: "O layout precisa ser uma lista de campos (array)." });
      return;
    }

    const semTipo = parsed.findIndex((field) => !field || typeof field.type !== "string");
    if (semTipo >= 0) {
      this.setState({
        error: `O item ${semTipo + 1} não tem "type" — todo campo precisa de um tipo.`,
      });
      return;
    }

    this.props.onApply(parsed);
  };

  render() {
    const { classes } = this.props;

    return (
      <Dialog open fullWidth maxWidth="md" onClose={this.props.onClose}>
        <DialogTitle>JSON do layout</DialogTitle>
        <DialogContent>
          <Typography variant="caption" color="textSecondary">
            O mesmo conteúdo de `layouts.options`. Aplicar substitui todos os
            campos — dá para desfazer depois com Ctrl/⌘ + Z do builder.
          </Typography>
          <TextField
            fullWidth
            multiline
            rows={22}
            variant="outlined"
            value={this.state.text}
            onChange={(event) => this.setState({ text: event.target.value, error: "" })}
            className={classes.editor}
            InputProps={{ classes: { input: classes.mono } }}
          />
          {this.state.error && (
            <Typography variant="caption" className={classes.error}>
              {this.state.error}
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.onClose}>Cancelar</Button>
          <Button variant="contained" color="primary" onClick={this.handleApply}>
            Aplicar
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

const styles = (theme) => ({
  editor: {
    marginTop: theme.spacing(1),
  },
  mono: {
    fontFamily: "monospace",
    fontSize: 12,
  },
  error: {
    color: "#c62828",
  },
});

export default withStyles(styles)(JsonDialog);
